import Cookies from "js-cookie";

async function get(url, headers) {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error in GET request:", error);
    throw error;
  }
}

async function post(url, body, headers = {}) {
  const params = {
    method: "POST",
    body: typeof body === "object" ? JSON.stringify(body) : body,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  };
  try {
    const response = await fetch(url, params);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error in POST request:", error);
    throw error;
  }
}

async function put(url, body, headers) {
  const params = {
    method: "PUT",
    body: JSON.stringify(body),
    headers,
  };
  const response = await fetch(url, params);
  return response;
}
async function del(url, headers) {
  const params = {
    method: "DELETE",
    headers,
  };
  const response = await fetch(url, params);
  return response;
}

async function getUnauthenticated(path, headers) {
  const lastUsedWorkspace = JSON.parse(
    localStorage.getItem("lastUsedWorkspace")
  );
  const scheme = lastUsedWorkspace.engine.scheme || "http://";
  const response = await get(
    `${scheme}://${lastUsedWorkspace.engine.host}${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.id}${path}`,
    {
      headers,
    }
  );
  if (!response) {
    throw Error(`response was null!`);
  }
  if (response.status === 403) {
    Cookies.set("token", null);
  }
  return response;
}

async function getAuthenticated(path, headers) {
  const lastUsedWorkspace = JSON.parse(
    localStorage.getItem("lastUsedWorkspace")
  );
  const scheme = lastUsedWorkspace.engine.scheme || "http://";
  const token = Cookies.get("token");
  const response = await get(
    `${scheme}://${lastUsedWorkspace.engine.host}${
      lastUsedWorkspace.engine.port ? `:${lastUsedWorkspace.engine.port}` : ""
    }${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.name}${path}`,
    {
      ...headers,
      Authorization: `Bearer ${token}`,
    }
  );
  if (!response) {
    throw Error(`response was null!`);
  }
  if (response.status === 403) {
    Cookies.set("token", null);
  }
  return response;
}

async function postUnauthenticated(path, body, headers) {
  const lastUsedWorkspace = JSON.parse(
    localStorage.getItem("lastUsedWorkspace")
  );
  const scheme = lastUsedWorkspace.engine.scheme || "http://";
  const url = `${scheme}://${lastUsedWorkspace.engine.host}${
    lastUsedWorkspace.engine.port ? `:${lastUsedWorkspace.engine.port}` : ""
  }${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.workspace}${path}`;
  const response = await post(url, body, headers);
  if (!response) {
    throw Error(`response was null!`);
  }
  if (response.status === 403) {
    Cookies.set("token", null);
  }
  return response;
}

async function postAuthenticated(path, body, headers) {
  const lastUsedWorkspace = JSON.parse(
    localStorage.getItem("lastUsedWorkspace")
  );
  const scheme = lastUsedWorkspace.engine.scheme || "http://";
  const token = Cookies.get("token");

  const graphqlUrl = `${scheme}://${lastUsedWorkspace.engine.host}${
    lastUsedWorkspace.engine.port ? `:${lastUsedWorkspace.engine.port}` : ""
  }${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.name}/graphql`;

  const buildGraphQLPayload = (type, input) => {
    const baseData = {
      name: input.name,
      description: input.description || "",
      // plant: { connect: { id: Number(input.plant_id) } },
      created_by: { connect: { id: 2 } },
      updated_by: { connect: { id: 2 } },
    };

    if (type === "shift") {
      return {
        mutation: `
          mutation CreateOneShift($data: ShiftCreateInput!) {
            createOneShift(data: $data) {
              id name description start_time end_time runs_on plant_id
            }
          }
        `,
        data: {
          ...baseData,
          plant: { connect: { id: Number(input.plant_id) } },
          start_time: input.start_time,
          end_time: input.end_time,
          runs_on: input.week_days,
        },
        responseKey: "createOneShift",
      };
    }

    if (type === "cycle") {
      return {
        mutation: `
          mutation CreateOneCycle($data: CycleCreateInput!) {
            createOneCycle(data: $data) {
              id name description plant_id
            }
          }
        `,
        data: {
          ...baseData,
          plant: { connect: { id: Number(input.plant_id) } },
        },
        responseKey: "createOneCycle",
      };
    }

    if (type === "part") {
      return {
        mutation: `
          mutation CreateOnePart($data: PartCreateInput!) {
            createOnePart(data: $data) {
              name description plant_id
            }
          }
        `,
        data: {
          ...baseData,
          plant: { connect: { id: Number(input.plant_id) } },
        },
        responseKey: "createOnePart",
      };
    }

    if (type === "cycle-stages") {
      return {
        mutation: `
          mutation CreateOneCycleStage($data: CycleStageCreateInput!) {
            createOneCycleStage(data: $data) {
              id name description duration is_productive
            }
          }
        `,
        data: {
          ...baseData,
          duration: input.duration,
          defaultDuration: input.duration,
          is_productive: input.is_productive,
          cycle: {
            connect: {
              id: Number(input.cycle_id),
            },
          },
        },
        responseKey: "createOneCycleStage",
      };
    }

    if (type === "zones") {
      return {
        mutation: `
          mutation CreateOneZone($data: ZoneCreateInput!) {
            createOneZone(data: $data) {
              id name description
              parent { id name }
              installed_devices { id name }
            }
          }
        `,
        data: {
          ...baseData,
          is_active: input.is_active ?? true,
          plant: { connect: { id: Number(input.plant_id) } },
          ...(input.parent_id != null
            ? { parent: { connect: { id: Number(input.parent_id) } } }
            : {}),
          ...(Array.isArray(input.selected_device_ids) &&
          input.selected_device_ids.length > 0
            ? {
                installed_devices: {
                  connect: input.selected_device_ids.map((id) => ({ id })),
                },
              }
            : {}),
        },
        responseKey: "createOneZone",
      };
    }
    return null;
  };

  const parsedBody = JSON.parse(body);
  const entity = parsedBody?.payload;

  let type = null;
  if (path.endsWith("/parts")) type = "part";
  if (path.endsWith("/cycles")) type = "cycle";
  if (path.endsWith("/shifts")) type = "shift";
  if (path.endsWith("/cycle-stages")) type = "cycle-stages";
  if (path.endsWith("/zones")) type = "zones";

  if (type) {
    const gqlPayload = buildGraphQLPayload(type, entity);

    const response = await fetch(graphqlUrl, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        query: gqlPayload.mutation,
        variables: { data: gqlPayload.data },
      }),
    });

    const result = await response.json();
    if (result.errors) {
      throw new Error(result.errors[0].message);
    }

    return {
      payload: result.data[gqlPayload.responseKey],
      status: 200,
    };
  }

  // Fallback to REST POST
  const url = `${scheme}://${lastUsedWorkspace.engine.host}${
    lastUsedWorkspace.engine.port ? `:${lastUsedWorkspace.engine.port}` : ""
  }${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.name}${path}`;

  const response = await post(url, body, {
    ...headers,
    Authorization: `Bearer ${token}`,
  });

  if (response.status === 403) {
    Cookies.set("token", null);
  }

  return response;
}

async function putUnauthenticated(path, body, headers) {
  const lastUsedWorkspace = JSON.parse(
    localStorage.getItem("lastUsedWorkspace")
  );
  const scheme = lastUsedWorkspace.engine.scheme || "http://";
  const response = await put(
    `${scheme}://${lastUsedWorkspace.engine.host}${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.id}${path}`,
    body,
    headers
  );
  if (!response) {
    throw Error(`response was null!`);
  }
  if (response.status === 403) {
    Cookies.set("token", null);
  }
  const responseJson = await response.json();
  return responseJson;
}

async function putAuthenticated(path, body, headers) {
  const lastUsedWorkspace = JSON.parse(
    localStorage.getItem("lastUsedWorkspace")
  );
  const scheme = lastUsedWorkspace.engine.scheme || "http://";
  const token = Cookies.get("token");

  const graphqlUrl = `${scheme}://${lastUsedWorkspace.engine.host}${
    lastUsedWorkspace.engine.port ? `:${lastUsedWorkspace.engine.port}` : ""
  }${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.name}/graphql`;

  const parsedBody = JSON.parse(body);
  const payload = parsedBody.payload;

  const getMatch = (type) =>
    path.match(new RegExp(`/plants/\\d+/${type}/(\\d+)`));

  const buildUpdatePayload = (type, entity) => {
    const baseData = {
      name: { set: entity.name },
      description: { set: entity.description || "" },
      plant: { connect: { id: Number(entity.plant_id) } },
      updated_by: { connect: { id: 2 } },
    };

    if (type === "shifts") {
      return {
        mutation: `
          mutation UpdateOneShift($data: ShiftUpdateInput!, $where: ShiftWhereUniqueInput!) {
            updateOneShift(data: $data, where: $where) {
              id name description start_time end_time runs_on plant_id
            }
          }
        `,
        data: {
          ...baseData,
          start_time: { set: entity.start_time },
          end_time: { set: entity.end_time },
          runs_on: { set: entity.week_days },
        },
        responseKey: "updateOneShift",
      };
    }

    if (type === "cycles") {
      return {
        mutation: `
          mutation UpdateOneCycle($data: CycleUpdateInput!, $where: CycleWhereUniqueInput!) {
            updateOneCycle(data: $data, where: $where) {
              id name description plant_id
            }
          }
        `,
        data: baseData,
        responseKey: "updateOneCycle",
      };
    }

    if (type === "parts") {
      return {
        mutation: `
          mutation UpdateOnePart($data: PartUpdateInput!, $where: PartWhereUniqueInput!) {
            updateOnePart(data: $data, where: $where) {
              name description plant_id
            }
          }
        `,
        data: baseData,
        responseKey: "updateOnePart",
      };
    }

    if (type === "cycle-stages") {
      return {
        mutation: `
          mutation UpdateOneCycleStage($data: CycleStageUpdateInput!, $where: CycleStageWhereUniqueInput!) {
            updateOneCycleStage(data: $data, where: $where) {
              id name description duration is_productive
            }
          }
        `,
        data: {
          ...baseData,
          duration: { set: entity.duration },
          is_productive: { set: entity.is_productive },
        },
        responseKey: "updateOneCycleStage",
      };
    }

    if (type === "zones") {
      return {
        mutation: `
      mutation UpdateOneZone($data: ZoneUpdateInput!, $where: ZoneWhereUniqueInput!) {
        updateOneZone(data: $data, where: $where) {
          id name description
          parent { id name }
          installed_devices { id name }
        }
      }
    `,
        data: {
          ...baseData,
          ...(entity.parent_id === null
            ? { parent: { disconnect: true } }
            : entity.parent_id !== undefined
            ? { parent: { connect: { id: Number(entity.parent_id) } } }
            : {}),
          ...(Array.isArray(entity.selected_device_ids) &&
          entity.selected_device_ids.length > 0
            ? {
                installed_devices: {
                  set: entity.selected_device_ids.map((id) => ({ id })),
                },
              }
            : {}),
        },
        responseKey: "updateOneZone",
      };
    }

    return null;
  };

  for (const type of ["parts", "cycles", "shifts", "cycle-stages", "zones"]) {
    const match = getMatch(type);
    if (match) {
      const id = Number(match[1]);
      const gqlPayload = buildUpdatePayload(type, payload);

      const response = await fetch(graphqlUrl, {
        method: "POST",
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          query: gqlPayload.mutation,
          variables: {
            data: gqlPayload.data,
            where: { id },
          },
        }),
      });

      const result = await response.json();
      if (result.errors) {
        throw new Error(result.errors[0].message);
      }

      return {
        payload: result.data[gqlPayload.responseKey],
        status: 200,
      };
    }
  }

  // Fallback to REST PUT for unknown routes
  const url = `${scheme}://${lastUsedWorkspace.engine.host}${
    lastUsedWorkspace.engine.port ? `:${lastUsedWorkspace.engine.port}` : ""
  }${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.name}${path}`;

  const response = await put(url, body, {
    ...headers,
    Authorization: `Bearer token`,
  });

  if (!response) {
    throw new Error("response was null!");
  }

  if (response.status === 403) {
    Cookies.set("token", null);
  }

  const responseJson = await response.json();
  return responseJson;
}

async function deleteAuthenticated(path, headers) {
  const lastUsedWorkspace = JSON.parse(
    localStorage.getItem("lastUsedWorkspace")
  );
  const scheme = lastUsedWorkspace.engine.scheme || "http://";
  const token = Cookies.get("token");

  const partIdMatch = path.match(/\/plants\/\d+\/parts\/(\d+)/);
  if (partIdMatch) {
    const partId = parseInt(partIdMatch[1], 10);
    const query = `
      mutation DeleteOnePart($where: PartWhereUniqueInput!) {
        deleteOnePart(where: $where) {
          id
          name
        }
      }
    `;

    const graphqlUrl = `${scheme}://${lastUsedWorkspace.engine.host}${
      lastUsedWorkspace.engine.port ? `:${lastUsedWorkspace.engine.port}` : ""
    }${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.name}/graphql`;

    const response = await fetch(graphqlUrl, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        query,
        variables: {
          where: { id: partId },
        },
      }),
    });

    const result = await response.json();

    if (result.errors) {
      throw new Error(result.errors[0].message);
    }

    return {
      payload: result.data.deleteOnePart,
      status: 200,
    };
  }

  const cycleStageMatch = path.match(
    /\/plants\/(\d+)\/cycles\/(\d+)\/cycle-stages\/(\d+)/
  );
  if (cycleStageMatch) {
    const stageId = parseInt(cycleStageMatch[3], 10);
    const query = `
      mutation DeleteOneCycleStage($where: CycleStageWhereUniqueInput!) {
        deleteOneCycleStage(where: $where) {
          id
          name
        }
      }
    `;

    const graphqlUrl = `${scheme}://${lastUsedWorkspace.engine.host}${
      lastUsedWorkspace.engine.port ? `:${lastUsedWorkspace.engine.port}` : ""
    }${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.name}/graphql`;

    const response = await fetch(graphqlUrl, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        query,
        variables: {
          where: { id: stageId },
        },
      }),
    });

    const result = await response.json();
    if (result.errors) {
      throw new Error(result.errors[0].message);
    }

    return {
      payload: result.data.deleteOneCycleStage,
      status: 200,
    };
  }

  const url = `${scheme}://${lastUsedWorkspace.engine.host}${
    lastUsedWorkspace.engine.port ? `:${lastUsedWorkspace.engine.port}` : ""
  }${process.env.REACT_APP_API_PREFIX}/${lastUsedWorkspace.name}${path}`;

  const response = await del(url, {
    ...headers,
    Authorization: `Bearer ${token}`,
  });

  const responseJson = await response.json();
  return responseJson;
}

export {
  get,
  post,
  put,
  del,
  getUnauthenticated,
  postUnauthenticated,
  putUnauthenticated,
  getAuthenticated,
  postAuthenticated,
  putAuthenticated,
  deleteAuthenticated,
};
